export default "__VITE_ASSET__47bfd7ef__"